import React from 'react';

export const TwitterIcon = ({ fill }: { fill?: string }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="100%" viewBox="0 0 24 24">
      <g data-name="Group 17421">
        <g data-name="Group 11898">
          {/* Outer circle */}
          <path
            data-name="Path 13667"
            d="M12 0a12 12 0 1 0 12 12A12 12 0 0 0 12 0z"
            style={{ fill: fill || '#181d56' }}
          />
        </g>
        {/* Inner path representing the new Twitter icon */}
        <path
          d="M20.27 5.152 24.7 0h-1.05L19.8 4.473 16.73 0h-3.545l4.648 6.764-4.648 5.4h1.05L18.3 7.443l3.246 4.724h3.544l-4.82-7.015zm-1.438 1.672-.471-.674L14.614.791h1.613l3.024 4.325.471.674 3.931 5.622h-1.614l-3.207-4.588z"
          transform="translate(-7.137 5.917)"
          style={{ fill: '#fff', stroke: '#fff', strokeWidth: '.4px' }}
        />
      </g>
    </svg>
  );
};
